import { render, staticRenderFns } from "./DrugCombinations.vue?vue&type=template&id=a6ee64f0&"
import script from "./DrugCombinations.vue?vue&type=script&lang=js&"
export * from "./DrugCombinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports